import { render, staticRenderFns } from "./TitleItem.vue?vue&type=template&id=05ee90df&scoped=true&"
import script from "./TitleItem.vue?vue&type=script&lang=js&"
export * from "./TitleItem.vue?vue&type=script&lang=js&"
import style0 from "./TitleItem.vue?vue&type=style&index=0&id=05ee90df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ee90df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ee90df')) {
      api.createRecord('05ee90df', component.options)
    } else {
      api.reload('05ee90df', component.options)
    }
    module.hot.accept("./TitleItem.vue?vue&type=template&id=05ee90df&scoped=true&", function () {
      api.rerender('05ee90df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/manageGoodsGroup/publishGoods/components/TitleItem.vue"
export default component.exports